import { createFileRoute } from '@tanstack/react-router';

import { PoemsScreen } from '../../features/personal/PoemsScreen';

/** `/personal/poems` = القصائد — قسمٌ مستقلّ بأمر المالك 2026-10-20. */
export const Route = createFileRoute('/personal/poems')({
  component: PoemsScreen,
});
